import { toggleAllInputsInContainer } from '@js/utilities/toggleInputsInContainer';

const changeKindGenderListener = () => {
    const changeKindGenderElement = document.querySelector('.js-change-kind-gender-engraving');
    const elementsToCollapse = [
        ...document.querySelectorAll('.js-change-kind-gender-engrave-container'),
    ];

    changeKindGenderElement.addEventListener('change', () => {
        elementsToCollapse.forEach((el) => {
            el.classList.add('d-none');
            toggleAllInputsInContainer(el, false);
        });

        const filteredElements = elementsToCollapse.filter((el) =>
            el.dataset.gender.split(',').find((ell) => ell === changeKindGenderElement.value)
        );

        filteredElements.forEach((el) => {
            el.classList.remove('d-none');
            toggleAllInputsInContainer(el, true);
        });
    });
};

const engravingElements = [...document.querySelectorAll('.js-engraving-element')];

let elementsToEnable = [];

window.addEventListener('old-model-set', async (e) => {
    if (window.returnsFormData.serviceType !== 'service_engraving') {
        return;
    }

    const { productType } = e.detail;

    engravingElements.forEach((el) => {
        el.classList.add('d-none');
        toggleAllInputsInContainer(el, false);
    });

    elementsToEnable = engravingElements.filter((el) => el.dataset.productType === productType);

    elementsToEnable.forEach((el) => {
        el.classList.remove('d-none');
        toggleAllInputsInContainer(el, true);
    });

    // console.log(product);
    // selectOldSizeValues(product);
});

const returnFormElement = document.querySelector('#returns-form');

returnFormElement.addEventListener('multi-step-form.step.changed', async (e) => {
    if (window.returnsFormData.serviceType !== 'service_engraving') {
        return;
    }

    if (e.detail.currentStep === 3) {
        const { initEngraveModule } = await import('@js/pages/product/engrave/engrave');

        elementsToEnable.forEach((el) => {
            const engraveModuleContainers = [...el.querySelectorAll('.js-engrave-module')].filter(
                (ell) => !ell.dataset.engraveInitialized
            );

            engraveModuleContainers.forEach((engraveModuleContainer) => {
                initEngraveModule(engraveModuleContainer);
                engraveModuleContainer.dataset.engraveInitialized = true;
            });
        });
    }
});

changeKindGenderListener();
